export const parseInputMask = (value: string) => {
  return (
    value
      .replace(/\)/g, "")
      .replace(/\(/g, "")
      .replace(/-/g, "")
      .replace(/ /g, "")
  )
};